import { createSlice } from "@reduxjs/toolkit";

const signupSlice=createSlice({
    name:"SignUp",
    initialState:{
        companyName:"",
        addressLine1:"",
        addressLine2:"",
        supplierType:undefined,
        country:undefined,
        state:undefined,
        zipcode:"",
        FirstName:"",
        LastName:"",
        userId:"",
        emailId:"",
        phoneNumber:"",
        userType:undefined,
        designation:undefined,
        additionalDetails:[

        ],
        existingSupplier:false,
        isUser:false,
        isExistingCompany:true,
        isErrorContactDetails:false,
        isErrorSupplierDetails:false,
        isErrorAdditionalDetails:false
    },
    reducers:{
        setCompanyName(state,action)
        {
            state.companyName=action.payload;
        },
        setAddressLine1(state,action)
        {
            state.addressLine1=action.payload;
        },
        setAddressLine2(state,action)
        {
            state.addressLine2=action.payload;
        },
        setSupplierType(state,action)
        {
            state.supplierType=action.payload;
        },
        setCountry(state,action)
        {
            state.country=action.payload;
        },
        setState(state,action)
        {
            state.state=action.payload;
        },
        setZipCode(state,action)
        {
            state.zipcode=action.payload;
        },
        setFirstName(state,action)
        {
            state.FirstName=action.payload;
        },
        setLastName(state,action)
        {
            state.LastName=action.payload;
        },
        setUserId(state,action)
        {
            state.userId=action.payload
        },
        setEmailId(state,action){
            state.emailId=action.payload
        },
        setPhoneNumber(state,action)
        {
            state.phoneNumber=action.payload
        },
        setUserType(state,action)
        {
            state.userType=action.payload;
        },
        setDesignation(state,action)
        {
            state.designation=action.payload;
        },
        setAdditionalDetail(state, action) {
           state.additionalDetails.push(action.payload);
          },
          removeAdditionalSupplier(state, action) {
            state.additionalDetails.splice(action.payload, 1);
          },
          resetAdditionalDetails(state){
            state.additionalDetails=[];
          },
          updateAdditionalDetails: (state, action) => {
            const { index, newValue } = action.payload;
            if (state.additionalDetails && index >= 0 && index < state.additionalDetails.length) {
                state.additionalDetails[index] = newValue;
            }
        },
        
        populateUserData(state, action) {
            const userData = action.payload;
            

            state.FirstName = userData.firstName || "";
            state.LastName = userData.lastName || "";
            state.userId=userData.userId || "";
            state.emailId = userData.emailId || "";
            state.phoneNumber = userData.phoneNumber || "";
            state.userType = userData.role || undefined;
            state.designation = userData.designation || undefined;
            state.companyName = userData.companyName || "";
            state.addressLine1 = userData.addressLine1 || "";
            state.addressLine2 = userData.addressLine2 || "";
            state.supplierType=userData.supplierType|| undefined;
            state.country = userData.country || undefined;
            state.state = userData.state || undefined;
            state.zipcode = userData.zipcode || "";
            

            if (userData.associatedSuppliers && Array.isArray(userData.associatedSuppliers)) {
                state.additionalDetails = userData.associatedSuppliers;
            }
        },
        setExistingSupplier(state,action){
            state.existingSupplier=action.payload;
        },
        setIsUser(state,action){
            state.isUser=action.payload;
        },
        setIsExistingCompany(state,action)
        {
            state.isExistingCompany=action.payload;
        },
        setIsErrorContactDetails(state,action)
        {
            state.isErrorContactDetails=action.payload;
        },
        setIsErrorSupplierDetails(state,action)
        {
            state.isErrorSupplierDetails=action.payload;
        },
        setIsErrorAdditionalDetails(state,action)
        {
            state.isErrorAdditionalDetails=action.payload;
        },
        resetSignup(state){
            state.companyName = "";
            state.addressLine1 = "";
            state.addressLine2 = "";
            state.supplierType=undefined;
            state.country = undefined;
            state.state = undefined;
            state.zipcode = "";
            state.FirstName = "";
            state.LastName = "";
            state.userId = "";
            state.emailId = "";
            state.phoneNumber = "";
            state.userType = undefined;
            state.designation = undefined;
            state.additionalDetails = [];
            state.existingSupplier = false;
        }
    }
})

export const { setCompanyName,setAddressLine1,setAddressLine2,setSupplierType,setCountry,setState,setZipCode,setFirstName,setLastName,setUserId,setEmailId,setPhoneNumber,setUserType,setDesignation,setAdditionalDetail,removeAdditionalSupplier,resetAdditionalDetails,updateAdditionalDetails,populateUserData,setExistingSupplier,resetSignup,setIsUser,setIsExistingCompany,setIsErrorSupplierDetails,setIsErrorAdditionalDetails,setIsErrorContactDetails} = signupSlice.actions;
export default signupSlice.reducer;